export default "__VITE_ASSET__CR5W0fMR__"